import { InfoPageBoldText } from './InfoPageBoldText.style';

export default InfoPageBoldText;
